import React from "react";

import { addUtmParamsToLinksAndPageNavigators } from "../../../Common/utils/NavigationUtils";
import { useValidateQueryParams } from "../../../Common/utils/hooks/QueryParams/useValidateQueryParams";

import Image from "../Image";
import "./Footer.css";

export default function Footer() {
  const verifiedUtm = useValidateQueryParams();
  return (
    <footer className="footer">
      <div className="div_block_183198052z">
        <a
          id="nxtwave-logo-footer"
          referrerPolicy="no-referrer-when-downgrade"
          href={addUtmParamsToLinksAndPageNavigators(
            verifiedUtm,
            "https://www.ccbp.in/"
          )}
          className="w_inline_block"
          style={{ marginBottom: "auto" }}
        >
          <Image
            width={117}
            height={66}
            alt="Nxtwave"
            src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/Nxtwave_White_logo.svg"
            loading="lazy"
            className="image_8128822196"
          />
        </a>
        <nav className="navigation">
          <a
            id="privacy-policy-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/privacy-policy"
            )}
            className="link"
          >
            Privacy Policy
          </a>
          <a
            id="cookie-policy-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/cookie-policy"
            )}
            className="link"
          >
            Cookie Policy
          </a>
          <a
            id="terms-and-conditions-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/terms-and-conditions"
            )}
            className="link"
          >
            Terms and Conditions
          </a>
          <a
            id="grievance-redressal-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/grievance-redressal"
            )}
            className="link"
          >
            Grievance Redressal
          </a>
          <a
            id="corporate-information-footer"
            referrerPolicy="no-referrer-when-downgrade"
            href={addUtmParamsToLinksAndPageNavigators(
              verifiedUtm,
              "https://www.ccbp.in/corporate-information"
            )}
            className="link"
          >
            Corporate Information
          </a>
        </nav>
      </div>
    </footer>
  );
}
